/**
 * Frisk godkendelse med sikkerhedsnøgle (YubiKey) på VPN-handlinger (beslutning 092).
 *
 * Når API'et svarer 401 med `code: "step_up_required"`, sender det en claims-anmodning med. API-klienten
 * spørger så den registrerede handler om et nyt token - handleren viser en dialog, og først når brugeren
 * trykker på knappen, åbnes Microsofts vindue (et popup skal startes af et klik, ellers blokeres det).
 * Med det nye token prøves kaldet én gang til.
 */

/** Returnerer et nyt access token - eller null, hvis brugeren fortrød. */
export type StepUpHandler = (claims: string, message: string) => Promise<string | null>

let handler: StepUpHandler | null = null

export function setStepUpHandler(next: StepUpHandler | null) {
  handler = next
}

export function requestStepUp(claims: string, message: string): Promise<string | null> {
  return handler ? handler(claims, message) : Promise.resolve(null)
}

export const STEP_UP_REQUIRED = 'step_up_required'
